module.exports = __webpack_public_path__ + "static/img/T-5.27978c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/T-5.png
// module id = pdW7
// module chunks = 6